import Box from "@mui/material/Box";
import React from "react";

const GridBreak = () => <Box width="100%" />;

export default GridBreak;
